import { inject, injectable } from "inversify";
import { CPLSettingsClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ISettingsService {
  getTermsAndConditions(): Promise<string | undefined>;
}

@injectable()
export class SettingsService implements ISettingsService {
  @inject(SERVICE_TYPES.CPLSettingsClient) cplSettingsClient!: CPLSettingsClient;

  async getTermsAndConditions(): Promise<string | undefined> {
    return (await this.cplSettingsClient.getTermsAndConditions()).termsAndConditionsContent;
  }
}
